<template>
  <footer class="footer footer-black footer-white">
    <div class="container-fluid">
      <div class="row">
        <nav class="footer-nav">
          <ul>
            <li>
              <a href="http://www.freelancedevelopercoach.com" target="_blank">Freelance Developer Coach</a>
            </li>
            <li>
              <a href="http://www.freelancedevelopercoach.com" target="_blank">Blog</a>
            </li>
          </ul>
        </nav>
        <div class="credits ml-auto">
          <div class="copyright">
            &copy; Coded with
            <i class="fa fa-heart heart"></i> by
            <a href="https://github.com/smartmaxdev" target="_blank">Maximiliano</a>.
            Designed by <a href="http://www.freelancedevelopercoach.com/?ref=pdf-vuejs" target="_blank">Freelance Developer Coach</a>.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'main-footer'
  }
</script>
<style>
</style>
